import { render, staticRenderFns } from "./FlashSalesGenerate.vue?vue&type=template&id=b366deae&"
import script from "./FlashSalesGenerate.vue?vue&type=script&lang=js&"
export * from "./FlashSalesGenerate.vue?vue&type=script&lang=js&"
import style0 from "./FlashSalesGenerate.vue?vue&type=style&index=0&id=b366deae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports